import { render, staticRenderFns } from "./AttachDocumentModal.vue?vue&type=template&id=1ebe64ac"
import script from "./AttachDocumentModal.vue?vue&type=script&lang=js"
export * from "./AttachDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports